import React, { useCallback, useEffect } from 'react';
import { useAuthService } from '@/services/authService';
import { debounce as _debounce } from 'lodash';

// Define props if needed, currently just children
interface AuthInitializerProps {
  children: React.ReactNode;
}

// Auth initialization component, wrapped in memo
const AuthInitializerComponent = React.memo(({ children }: AuthInitializerProps) => {
  const { checkAuthStatus } = useAuthService();

  const debouncedCheckAuthStatus = useCallback(_debounce(checkAuthStatus, 1000), []);

  useEffect(() => {
    // Determine if we're on an auth page (e.g., login, signup)
    const isAuthPage =
      typeof window !== 'undefined' &&
      ['/login', '/register', '/forgot-password', '/reset-password'].includes(window.location.pathname);

    // Call checkAuthStatus from the service if not on a public auth page
    if (!isAuthPage) {
      console.log('AuthInitializer Effect Running...');
      debouncedCheckAuthStatus();
    } else {
      console.log('AuthInitializer: On auth page, skipping initial status check.');
    }
    // Dependency array ensures this runs only when checkAuthStatus reference changes
    // (which it shouldn't, thanks to useCallback in useAuthService)
  }, [debouncedCheckAuthStatus]);

  // Render children immediately; loading state handled elsewhere if needed
  return <>{children}</>;
});

// Add display name for better debugging
AuthInitializerComponent.displayName = 'AuthInitializer';

export default AuthInitializerComponent;
